import { render, staticRenderFns } from "./LeftText.vue?vue&type=template&id=e5a2a460&scoped=true"
import script from "./LeftText.vue?vue&type=script&lang=js"
export * from "./LeftText.vue?vue&type=script&lang=js"
import style0 from "./LeftText.vue?vue&type=style&index=0&id=e5a2a460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a2a460",
  null
  
)

export default component.exports